import { UserMembershipDetail } from 'components/loyalty-program/user-membership-detail/UserMembershipDetail'
import { useLocation, useSearchParams } from 'react-router-dom'
import { convertErrorMessage, downloadFile, getAllQueryParams, setQueryParams } from 'utils/utils'
import { INITIAL_DATA_FILTER } from 'configs/loyalty-program/configTableUserMembershipDetail'
import { useEffect, useState } from 'react'
import { Alert } from 'avo-ui'
import { ACTION_TYPE } from 'constants/constant'
import { useFetch } from 'services/useFetch'
import { API_USER_MEMBERSHIP } from 'services/apiUserMembership'
import moment from 'moment/moment'

const INIT_STATE = {
    amount: null,
    description: null,
}

const GET_FIELD_NAME = {
    amount: 'Nilai point',
    description: 'Deskripsi',
}

export const UserMembershipDetailContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const userId = searchParams.get('userId')
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const [pointDetail, setPointDetail] = useState({})
    const [actionForm, setActionForm] = useState(ACTION_TYPE?.ADD)
    const [errorForm, setErrorForm] = useState({})
    const { fetching: addPoint, isAdding } = useFetch(API_USER_MEMBERSHIP.ADD_POINT)
    const { fetching: reducePoint, isReducing } = useFetch(API_USER_MEMBERSHIP.REDUCE_POINT)
    const { fetching: exportUserMembershipDetail, isExporting } = useFetch({
        ...API_USER_MEMBERSHIP.EXPORT_DETAIL,
        initPathVariable: userId,
    })
    const {
        fetching: getUserMembershipDetail,
        data: userMembershipDetail,
        isLoading,
    } = useFetch({ ...API_USER_MEMBERSHIP.DETAIL, initPathVariable: userId })
    const {
        fetching: getUserMembershipProfile,
        data: userMembershipProfile,
        isLoading: isLoadingProfile,
    } = useFetch({ ...API_USER_MEMBERSHIP.PROFILE, initPathVariable: userId }, {}, { isFetching: true })
    const [modal, setModal] = useState({
        export: false,
        form: false,
    })

    useEffect(() => {
        fetchUserMembershipDetailList()
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const fetchUserMembershipDetailList = () => {
        const newItem = { ...INITIAL_DATA_FILTER, ...query }
        getUserMembershipDetail(newItem)
    }

    const setShowModal = (item) => {
        setModal({ ...modal, ...item })
    }

    const setShowAlert = (message, itemModal) => {
        setShowModal(itemModal)
        return Alert({
            icon: 'success',
            title: 'Success',
            message,
        })
    }

    const onHideForm = () => {
        setShowModal({ form: false })
        setErrorForm({})
    }

    const onActionRow = (type) => {
        setActionForm(type)
        setPointDetail(INIT_STATE)
        setShowModal({ form: true })
    }

    const onChangeForm = (e) => {
        const { name, value } = e
        setPointDetail({ ...pointDetail, [name]: value })
    }

    const onExport = () => {
        exportUserMembershipDetail({}, '', {}, 'blob').then((response) => {
            downloadFile(null, response, `User-Membership-Detail-Export-${moment().format('DD-MM-YYYY')}.xlsx`)
            setShowAlert('User Membership Detail Exported', { export: false })
        })
    }

    const validateForm = () => {
        const validateTotalPoint = (key) => {
            let message
            const totalPoint = userMembershipProfile?.data?.total_point
            if (actionForm === ACTION_TYPE?.REDUCE && !totalPoint) {
                message = `${GET_FIELD_NAME[key]} tidak bisa dikurangi`
            } else if (Number(pointDetail[key]) === 0) {
                message = `${GET_FIELD_NAME[key]} harus lebih dari 0`
            } else if (actionForm === ACTION_TYPE?.REDUCE && Number(pointDetail[key]) > totalPoint) {
                message = `${GET_FIELD_NAME[key]} harus lebih kecil atau sama dengan total point`
            }
            return message
        }

        return new Promise((resolve, reject) => {
            let errors = {}
            Object.keys(pointDetail).forEach((key) => {
                if (GET_FIELD_NAME[key] && !pointDetail[key]?.toString()) {
                    errors[key] = `${GET_FIELD_NAME[key]} wajib diisi`
                } else if (key === 'amount' && validateTotalPoint(key)) {
                    errors[key] = validateTotalPoint(key)
                }
            })

            setErrorForm(errors)
            if (!Object.keys(errors).length) resolve()
        })
    }

    const onSubmit = () => {
        validateForm().then(() => {
            const payload = {
                ...pointDetail,
                id: userId,
            }
            if (actionForm === ACTION_TYPE?.ADD) {
                addPoint(payload)
                    .then(() => {
                        setShowAlert('Point Added !', { form: false })
                        fetchUserMembershipDetailList()
                        getUserMembershipProfile()
                    })
                    .catch((error) => setErrorForm(convertErrorMessage(error?.data, GET_FIELD_NAME)))
            } else {
                reducePoint(payload)
                    .then(() => {
                        setShowAlert('Point Reduced !', { form: false })
                        fetchUserMembershipDetailList()
                        getUserMembershipProfile()
                    })
                    .catch((error) => setErrorForm(convertErrorMessage(error?.data, GET_FIELD_NAME)))
            }
        })
    }

    const props = {
        dataList: userMembershipDetail?.data,
        userProfile: userMembershipProfile?.data,
        modal,
        setShowModal,
        query,
        onChangeQuery,
        onExport,
        onActionRow,
        onChangeForm,
        onSubmit,
        onHideForm,
        actionForm,
        errorForm,
        pointDetail,
        isLoading,
        isLoadingProfile,
        isExporting,
        isAdding,
        isReducing,
    }

    return <UserMembershipDetail {...props} />
}
